import { HEADER_BACKGROUND_IMAGE } from './constants.ts';
import LandingNav from './LandingNav.tsx';

const HeaderLanding = (): JSX.Element => (
    <div
        className="relative bg-repeat-x py-4"
        style={{ backgroundImage: `url(${HEADER_BACKGROUND_IMAGE})` }}
    >
        <div
            aria-hidden="true"
            className="absolute inset-0 bg-blue-900 opacity-70 bg-gradient-to-b from-blue-900/70 to-blue-900/60"
        ></div>
        <LandingNav className="relative" />
    </div>
);

export default HeaderLanding;
